<template>
    <div class="modal fade" id="helpModal" tabindex="-1" role="dialog" aria-labelledby="helpModalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="helpModalLabel">{{ modalTitle }}</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body  text-dark">

                    <div v-if="id=='authorInfo-image'">
                        <p>Kysymme tätä, jotta voimme olla kuvaajaan yhteydessä kuvan mahdollisesta näyttelykäytöstä. Kiitos avustasi!</p>
                    </div>

                    <div v-if="id=='authorInfo-video'">
                        <p>Kysymme tätä, jotta voimme olla tallenteen tekijään yhteydessä tallenteen mahdollisesta näyttelykäytöstä. Kiitos avustasi!</p>
                    </div>

                    <div v-if="id=='authorInfo-audio'">
                        <p>Kysymme tätä, jotta voimme olla äänitteen tekijään yhteydessä tallenteen mahdollisesta näyttelykäytöstä. Kiitos avustasi!</p>
                    </div>

                    <div v-if="id=='howIGotIt-image'">
                        <p>Jos et ottanut kuvaa, kerro meille, miten kuva on päätynyt sinulle. Näin autat meitä aineiston käsittelyssä. Kiitos avustasi!</p>
                    </div>

                    <div v-if="id=='howIGotIt-video'">
                        <p>Jos et ole tallenteen tekijä, kerro meille, miten tallenne on päätynyt sinulle. Näin autat meitä aineiston käsittelyssä. Kiitos avustasi!</p>
                    </div>

                    <div v-if="id=='howIGotIt-audio'">
                        <p> Jos et ole tallenteen tekijä, kerro meille, miten tallenne on päätynyt sinulle. Näin autat meitä aineiston käsittelyssä. Kiitos avustasi!</p>
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Sulje</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HelpModal',
    props: {
        id:  String,
        title: String
    },
    computed: {
        modalTitle() {
            if (this.title) {
                return this.title;
            }
            return 'Ohje';
        }
    }
}
</script>

<style scoped>

</style>
